/**
 * Get all entities based on entity type
 * @param { Object } state
 * @param { String } entityType
 */
export const getEntities = (state, entityType) => state.entities[entityType];
